import React, { useState } from "react";
import { Type } from "lucide-react";
import Button from "../../../components/core/Element/Button/Button";

const Fonts = () => {
  const [selectedFont, setSelectedFont] = useState("Inter");

  const fontOptions = [
    { name: "Inter", sample: "Modern & Clean (Default)", family: "'Inter', sans-serif" },
    { name: "Poppins", sample: "Friendly & Geometric", family: "'Poppins', sans-serif" },
    { name: "Roboto", sample: "Classic & Versatile", family: "'Roboto', sans-serif" },
    { name: "Montserrat", sample: "Bold & Stylish", family: "'Montserrat', sans-serif" },
    { name: "Outfit", sample: "Premium & Contemporary", family: "'Outfit', sans-serif" },
  ];

  return (
    <div className="d-flex flex-column gap-4 bg-light mt-3 p-3 rounded">
      <div>
        <h3>Store Typography & Fonts</h3>
        <p className="text-muted">
          Choose a typography style for headings and menu items on your store homepage.
        </p>
      </div>

      <div className="card p-3 border-0 shadow-sm">
        <h5 className="mb-3 d-flex align-items-center gap-2">
          <Type size={18} /> Available Font Families
        </h5>

        <div className="row g-3">
          {fontOptions.map((font) => (
            <div key={font.name} className="col-md-6">
              <div
                className={`p-3 border rounded cursor-pointer transition-all ${
                  selectedFont === font.name ? "border-primary bg-light shadow-sm" : ""
                }`}
                onClick={() => setSelectedFont(font.name)}
                style={{ fontFamily: font.family }}
              >
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <h6 className="mb-0 fw-bold">{font.name}</h6>
                  {selectedFont === font.name && (
                    <span className="badge bg-primary">Active</span>
                  )}
                </div>
                <p className="text-muted mb-0 small">{font.sample}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4">
          <Button label="Apply Font" onClick={() => alert(`Font set to ${selectedFont}`)} />
        </div>
      </div>
    </div>
  );
};

export default Fonts;
